import React, { Component } from "react";
import { Link, graphql } from "gatsby";
import Layout from "../layout";
import IconTwitter from "../../icons/icon-twitter.svg";
import IconLinkedin from "../../icons/icon-linkedin.svg";
import IconFacebook from "../../icons/icon-facebook.svg";
import IconCharge from '../../icons/icon-charge.svg';
import he from 'he';
import { TwitterShareButton, FacebookShareButton, LinkedinShareButton } from 'react-share';
import BlogGrid from "./blog-grid";
import { GatsbyImage } from "gatsby-plugin-image";
import IconCheckmarkImage from "../../icons/icon-checkmark.svg";
import { submitForm, emailRegX } from '../common/templates/form/submitForm';
import SEO from '../../components/seo';
import { Helmet } from "react-helmet";
import LazyLoad from 'react-lazyload';
import BlogPopupDownload from '../blogs/BlogPopupDownload'
import 'react-phone-input-2/lib/style.css';
import $ from "jquery";
import scrollTo from 'gatsby-plugin-smoothscroll';
import { decode } from 'he';
import ConvertHTMLToText from "../common/utils/html-to-text";
import Mailbox from './mailBox';

const replaceImageURLS = (string) => {
  return string.replace(/testingsite01.rapidops/g, 'mk0rapidopsback40h4t.kinstacdn');
};

/* const extract = (string, prefix, suffix) => {
  let s = string;
  var i = s.indexOf(prefix);
  if (i >= 0) {
    s = s.substring(i + prefix.length);
  }
  else {
    return '';
  }
  if (suffix) {
    i = s.indexOf(suffix);
    if (i >= 0) {
      s = s.substring(0, i);
    }
    else {
      return '';
    }
  }
  return s.replace(/testingsite01./g, 'www.');
}; */

class ArticlePage extends Component {
  constructor(props) {
    super(props);
    this.textInput = null;
    this.referrer = null;

    this.state = {
      emailField: "",
      emailValidation: "",
      submitButtonState: "",
      isPopupVisible: false,
      headingElements: [],
      shouldHeaderSectionVisible: false
    };
  }

  clearFields = () => {
    this.setState({
      emailField: "",
      emailValidation: "",
      //submitButtonState: "",
    });
  };

  handleEmailField = (event) => {
    event.preventDefault();
    const { value } = event.target;
    const validation = emailRegX.test(value) ? 'success-field' : 'error-field';
    this.setState({
      emailField: value,
      emailValidation: validation
    });
  };

  async componentDidMount() {
    $('.sticky-checkbox').prop('checked', true);

    const tempHeadingElements = document.querySelectorAll("#BlogContentDiv h2");

    tempHeadingElements.forEach((ele, i) => {
      ele.id = "a" + i;
    })

    setTimeout(() => {
      $('.inside-topics .inside-topics-ul').show();
      $( ".inside-topics .inside-topics-ul li" ).each(function( index ) {
        let element = $(this);
        element.text(element.text().replace("1. ", "").replace("1. ", "").replace("2. ", "").replace("3. ", "").replace("4. ", "").replace("5. ", "").replace("6. ", "").replace("7. ", "").replace("8. ", "").replace("9. ", "").replace("10. ", "").replace("11. ", "").replace("12. ", "").replace("13. ", "").replace("14. ", "").replace("15. ", "").replace("16. ", "").replace("17. ", "").replace("18. ", "").replace("19. ", "").replace("20. ", ""));
      });
    }, 1000);

    this.setState({
      headingElements: Array.from(tempHeadingElements)
    }, () => {
      if (this.state.headingElements.length === 0) {
        this.setState({
          shouldHeaderSectionVisible: false
        })
      }
      else {
        this.setState({
          shouldHeaderSectionVisible: true
        })
      }
    })

    const allTags = this.props.data.wordpressPost.tags;

    await allTags.map(ele => {
      if (ele.name === "Logistics" || ele.name === "Supply Chain" || ele.name === "Manufacturing") {
        this.setState({
          isPopupVisible: true,
        })
      }
      return null;
    })

    window.addEventListener('scroll', this.handleScrollStickySection, true)

    if (this.state.isPopupVisible) {
      window.addEventListener('scroll', this.handleScrollPopup, true);
    }

    const accordion = document.getElementsByClassName('schema-faq-section');

    for (let i=0; i<accordion.length; i++) {
      accordion[i].addEventListener('click', function () {
        this.classList.toggle('active')
      })
    } 
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScrollStickySection);
    window.removeEventListener('scroll', this.handleScrollPopup)
  }

  onSubmit = async (event) => {
    event.preventDefault();
    if (this.state.emailValidation === 'success-field') {
      this.setState({
        submitButtonState: "inProgress"
      });
      const requestData = {
        method: "post",
        url: "https://rapidopsbackend.kinsta.cloud/wp-json/gf/v2/entries",
        data: {
          "form_id": "2",
          "1": this.state.emailField,
        },
      };
      const response = await submitForm(requestData);
      if (response.status === 201) {
        setTimeout(() => {
          this.setState({
            submitButtonState: "finished",
          });
        }, 1500);
      }
      setTimeout(() => {
        this.clearFields();
      }, 3000);
    }
  };

  handleScrollStickySection = () => {
    let scrollY = window.scrollY;
    let windowHight = $(window).height() * 2;
    if (scrollY > windowHight) {
      $('.sticky-cta-section').addClass('show-sticky-cta');
    } else {
      //$('.sticky-cta-section').removeClass('show-sticky-cta');
    }
  };

  handleScrollPopup = () => {
    let scrollY = window.scrollY;
    let windowHight = $(window).height();

    if (this.state.isPopupVisible) {
      if (scrollY > windowHight) {
        $('.blogPage-download-popup').addClass('show-popup');
      } else {
        $('.blogPage-download-popup').removeClass('show-popup');
      }
    }
  };

  helperMethod = () => {

  }

  render() {
    const { author, path, title, acf, featured_media, content, modifiedISO, publishedISO } = this.props.data.wordpressPost;
    const currentBlogCategories = this.props.data.wordpressPost.categories;
    //const AllCategories = this.props.data.allWordpressCategory.edges;
    const bannerLayout = !acf.blog_template || acf.blog_template === "default" ? "" : "blog-custom-layout";
    const authorDescription = author.description.split("--");
    let seoData;

    const { location } = this.props

    for (const data of this.props.pageContext.jsonld[0].wordpress__graph) {
      if (data.wordpress__id.includes('blog') && data.name !== null && data.wordpress__id.includes('#webpage'))
        seoData = { name: data.name, desc: data.description };
    }
    //console.log(content);
    const newContent = (typeof content === "string") ? replaceImageURLS(content) : content;
    const postContent = ConvertHTMLToText({ html: decode(newContent)})
    const wpm = 200;
    const totalWords = postContent.trim().split(/\s+/).length;
    const readTime = Math.ceil(totalWords/wpm);

    const authorImageSrc = (typeof author.acf.profile_picture.source_url === "string") ? replaceImageURLS(author.acf.profile_picture.source_url) : author.acf.profile_picture.source_url;
    //const allYoastHTML = he.decode(yoast_head);
    const { isPopupVisible } = this.state;
    return (
      <Layout addBodyClass={`blog-page-template white-header ${bannerLayout}`}>
        <SEO description={seoData.desc}
          meta={[{ name: "charSet", content: "utf-8" }]}
          title={seoData.name} />
        <Helmet>
          <meta property="og:image" content={replaceImageURLS(featured_media.source_url)} />
          <meta property="og:image:width" content={featured_media.width} />
          <meta property="og:image:height" content={featured_media.height} />
          <meta name="twitter:card" content="summary_large_image" />
          <script type="application/ld+json">
            {/* {extract(allYoastHTML, `<script type="application/ld+json" class="yoast-schema-graph">`, `</script>`)} */}
            {`{"@context":"https://schema.org","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.rapidops.com/${path}"},"headline":"${he.decode(title)}","description":"${he.decode(title)}","image":"${replaceImageURLS(featured_media.source_url)}","author":{"@type":"Person","name":"${author.name}"},"publisher":{"@type":"Organization","name":"Rapidops","logo":{"@type":"ImageObject","url":"https://www.rapidops.com/rapidopslogo.png"}},"datePublished":"${publishedISO}","dateModified":"${modifiedISO}"}`}
          </script>
        </Helmet>
        <div className={`page-main-banner-section-article-1 ${bannerLayout}`}>
          <div className="container">
            <div className="row d-flex flex-wrap align-v-center justify-center">
              <div className="col page-main-banner-bg">
                {featured_media.localFile && featured_media.localFile.childImageSharp ?
                  <LazyLoad><GatsbyImage
                    image={featured_media.localFile.childImageSharp.gatsbyImageData}
                    alt={featured_media.alt_text} /></LazyLoad> :
                  <LazyLoad><img src={featured_media.source_url} alt={featured_media.alt_text} /></LazyLoad>}
              </div>

            </div>
          </div>
        </div>

        <div className="article-main-section">
          <div className="container">
            <div className="section-gap-small">
              <div className="row d-flex flex flex-wrap align-start">
                {/* <div className="col more-topics-mobile">
                  <h4>MORE Topics</h4>
                  <CategorySelect categories={AllCategories} currentCategory={currentBlogCategories[0].name} totalPosts={this.props.data.totalPosts.totalCount} />
                </div> */}
                <div className="col article-info">
                  <div className="page-main-banner-detail">
                    <p className="category-name">
                      {
                        currentBlogCategories.map((category, i) => {
                          if (!category.slug.includes('everything'))
                            {
                              return (
                                <Link key={i} to={'/blog/category/' + category.slug + '/'}>
                                  {he.decode(category.name)}
                                </Link>);
                            }
                          return null;
                        })
                      }
                        <span className="blog-time-read">{readTime} Min read</span>
                    </p>
                    <h1>{he.decode(title)}</h1>
                    
                  </div>
                  <div className="social-share">

                    <ul>

                      <li className="share-facebook">
                        <FacebookShareButton
                          url={this.props.location.href}
                          quote={title}
                          rel="nofollow">
                          <IconFacebook />
                        </FacebookShareButton>
                      </li>

                      <li className="share-twitter">
                        <TwitterShareButton
                          url={this.props.location.href}
                          quote={title}>
                          <IconTwitter />
                        </TwitterShareButton>
                      </li>

                      <li className="share-linkedin"><LinkedinShareButton
                        url={this.props.location.href}
                        quote={title}>
                        <IconLinkedin />
                      </LinkedinShareButton>
                      </li>
                    </ul>
                  </div>
                  <div id="BlogContentDiv" className="wysiwing" dangerouslySetInnerHTML={{ __html: newContent }} />

                  <div className="author-info">
                    <div className="auther-image">
                      <LazyLoad>
                        <img src={authorImageSrc} alt={author.acf.profile_picture.alt_text} />
                      </LazyLoad>
                    </div>
                    <div className="author-desc">
                      <h5>{author.name}</h5>
                      {
                        authorDescription[1] &&
                        <>
                          <h6>{authorDescription[0]}</h6>
                          <p>{authorDescription[1]} </p>
                        </>
                      }
                      {
                        !authorDescription[1] &&
                        <p>{authorDescription[0]}</p>
                      }
                    </div>
                  </div>
                </div>
                <div className="col article-sidebar" id="headerNavigation">
                  {
                    this.state.shouldHeaderSectionVisible &&
                    <div className="inside-topics">
                      <h4>What's INSIDE</h4>
                      <ol className="inside-topics-ul">
                        {
                          this.state.headingElements.map((ele, i) => {
                            return (<li key={i} onClick={() => scrollTo(`#${ele.id}`)} >{ele.innerText}</li>)
                          })
                        }
                      </ol>
                    </div>
                  }


                  {
                    this.props.data.wordpressPost.acf.cta_title &&
                    <div className="blog-case-study cs-infographic-compass blog-cs-small">
                      <div className="row d-flex align-v-center flex-wrap">
                        <div className="col blog-case-study-content">
                          <div className="theme-color-sub-title">{this.props.data.wordpressPost.acf.cta_subtitle}</div>
                          <h2>{this.props.data.wordpressPost.acf.cta_title}</h2>
                          <p>
                            <Link className="button button-small right-arrow button-white-border" to={this.props.data.wordpressPost.acf.cta_button_link} >{this.props.data.wordpressPost.acf.cta_button_text}</Link>
                          </p>
                        </div>
                        <div className="col blog-case-study-image">
                          <img src={this.props.data.wordpressPost.acf.cta_image.source_url} alt="digital transformation in manufacturing" />
                        </div>
                        <p></p>
                      </div>
                    </div>
                  }


                  <div className="mailbox small">
                    <div className="row d-flex flex-wrap">
                      <div className="col mailboxInfo">
                        <h3>Receive articles like this in your mailbox</h3>
                        <p>Sign up to get weekly insights & inspiration in your inbox.</p>
                      </div>
                      <div className="col mailboxForm">

                        {/* email form */}
                        <form name="mailboxForm" onSubmit={this.onSubmit} className="fomt-style-fancy mailbox-form d-flex">
                          <div className="input-mailbox">
                            <input
                              //onBlur={() => this.setState({ emailValidation: '' })}
                              onFocus={e => {
                                const validation = emailRegX.test(e.target.value) ? 'success-field' : 'error-field';
                                this.setState({ emailValidation: validation });
                              }}
                              placeholder="Enter work email"
                              type="email"
                              name="email"
                              className={`form-input ${this.state.emailValidation}`}
                              id="work-email"
                              autoComplete="off"
                              onChange={this.handleEmailField} required value={this.state.emailField || ""} />
                          </div>
                          <div className="mailbox-action">
                            <button type="submit" className={`button right-arrow ${this.state.submitButtonState}`}>
                              <span className="submit">Subscribe</span>
                              <span className="loading">Subscribe</span>
                              <span className="check"> <IconCheckmarkImage /> </span>
                            </button>
                          </div>
                        </form>
                        {this.state.submitButtonState === 'finished' && <p className="reading-info">Thank you for subscribing! </p>}
                        <p className="reading-info"><IconCharge /><strong>2500 people</strong> are reading this blog every week</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dt-cta-section section-gap">
              <div className="container">
                <div className="dt-cta-inner">
                  <div className="leftbar">
                    <h2>Let’s discuss your analytics opportunity.</h2>
                    <h3>Unlock your digital transformation opportunities now!</h3>
                  </div>
                  <div className="rightbar">
                    <a className="button button-white right-arrow" href="/contact/">Get Started</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <BlogGrid title={<h3>Similar Stories</h3>} categoryPosts={this.props.data.categoryPosts}
            blogTitle={this.props.data.wordpressPost.title} servicePage={false} />
        </div>
        <div>
          {isPopupVisible && <BlogPopupDownload location={location} />}
        </div>
        <Mailbox />
        {/*<FormSection className="site-footer-form" />*/}
      </Layout>
    );
  }
};

export default ArticlePage;

export const postQuery = graphql`query ($id: String!, $categorySlug: String) {
  wordpressPost(id: {eq: $id}) {
    tags {
      name
    }
    author {
      name
      url
      avatar_urls {
        wordpress_24
        wordpress_48
        wordpress_96
      }
      acf {
        profile_picture {
          source_url
          alt_text
        }
      }
      description
    }
    content
    date(formatString: "MMMM DD, YYYY")
    publishedISO: date
    path
    title
    template
    categories {
      name
      slug
    }
    featured_media {
      alt_text
      source_url
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      media_details {
        height
        width
      }
    }
    modified(fromNow: true)
    modifiedISO: modified
    acf {
      blog_template
      cta_button_link
      cta_button_text
      cta_image {
        source_url
      }
      cta_subtitle
      cta_title
    }
    yoast_head
    yoast_json_ld {
      wordpress__graph {
        wordpress__id
        name
        description
        inLanguage
        width
        height
        caption
        datePublished
        dateModified
      }
    }
  }
  allWordpressCategory {
    edges {
      node {
        count
        name
        slug
      }
    }
  }
  totalPosts: allWordpressPost {
    totalCount
  }
  categoryPosts: allWordpressPost(
    sort: {order: DESC, fields: date}
    filter: {categories: {elemMatch: {slug: {eq: $categorySlug}}}}
    limit: 5
  ) {
    edges {
      node {
        title
        featured_media {
          alt_text
          source_url
          localFile {
            childImageSharp {
              gatsbyImageData(width: 860, layout: CONSTRAINED)
            }
          }
        }
        acf {
          lending_page_image {
            source_url
            alt_text
          }
        }
        slug
        content
        date(formatString: "MMMM DD, YYYY")
        categories {
          name
          slug
        }
      }
    }
  }
}
`;